import {
  ORGANIZATION_CREATE_SUCCESS,
  ORGANIZATION_LIST_SUCCESS,
  ORGANIZATION_INFO_SUCCESS,
  ORGANIZATION_FILTER_HANDLING,
  ORGANIZATION_SEARCH_NAME,
  ORGANIZATION_UPDATE_SUCCESS,
} from "../actionTypes/organization";

const INIT_STATE = {
  organizationList: [],
  isSuccess: false,
  organizationInfo: {},
  queryInfo: {
    page: 1,
    size: 10,
    next: false,
  },
  totalRecords: 0,
  page: 1,
  columnHandling: [
    {
      id: "Name",
      key: "name",
      label: "Name",
      align: "left",
      pading: "0 3",
      visibility: true,
      isFilter: true,
    },
    {
      id: "Email",
      key: "email",
      label: "Email",
      align: "left",
      visibility: true,
      isFilter: true,
    },
    {
      id: "ContactNumber",
      key: "contactNumber",
      label: "Contact Number",
      align: "left",
      visibility: true,
      isFilter: true,
    },
    {
      id: "IdNumber",
      key: "idNumber",
      label: "ID Number",
      align: "left",
      visibility: false,
      isFilter: true,
    },
    {
      id: "Country",
      key: "country",
      label: "Country",
      align: "left",
      visibility: true,
      isFilter: true,
    },
    {
      id: "City",
      key: "city",
      label: "City",
      align: "left",
      visibility: true,
      isFilter: true,
    },
    {
      id: "Address",
      key: "address",
      label: "Address",
      align: "left",
      visibility: false,
      isFilter: true,
    },
    {
      id: "PostalCode",
      key: "postalCode",
      label: "Postal Code",
      align: "left",
      visibility: false,
      isFilter: true,
    },
    {
      id: "Status",
      key: "active",
      label: "Status",
      align: "left",
      visibility: false,
      isFilter: true,
    },
    {
      id: "CreatedAt",
      key: "createdAt",
      label: "Created At",
      align: "left",
      visibility: false,
      isFilter: true,
    },
    {
      id: "Action",
      key: "action",
      label: "Action",
      align: "left",
      visibility: true,
      isFilter: false,
    },
  ],
  searchName: "",
  searchStatus: false,
  organizationType: "Active",
  isUpdate: false,
};

function OrganizationReducer(state = INIT_STATE, action) {
  const { type, payload } = action;

  switch (type) {
    case ORGANIZATION_LIST_SUCCESS: {
      console.log({ payload });
      return {
        ...state,
        searchStatus: false,
        organizationList: payload.data,
        queryInfo: {
          ...payload.queryInfo,
        },
        totalRecords: payload.totalRecords,
        isSuccess: false,
        // page: payload.queryInfo.page || 0
      };
    }

    case ORGANIZATION_CREATE_SUCCESS: {
      console.log({ payload });
      return {
        ...state,
        organizationList: [payload.data, ...state.organizationList],
        isSuccess: true,
      };
    }

    case ORGANIZATION_UPDATE_SUCCESS: {
      console.log({ payload });
      return {
        ...state,
        organizationList: state.organizationList.map(
          (obj) => (payload.data._id === obj._id ? payload.data : obj)
          // data.columnHandling.map((row) => obj.id === row)
        ),
        organizationInfo: payload.data,
        isSuccess: true,
        isUpdate: true,
      };
    }

    case ORGANIZATION_INFO_SUCCESS: {
      console.log({ payload });
      return {
        ...state,
        organizationInfo: payload.data,
        // isSuccess: true
      };
    }
    case ORGANIZATION_FILTER_HANDLING: {
      console.log({ payload });
      return {
        ...state,
        columnHandling: payload.columnHandling,
        organizationType: payload.organizationType,
      };
    }
    case ORGANIZATION_SEARCH_NAME: {
      console.log({ payload });
      return {
        ...state,
        searchName: payload,
        searchStatus: true,
        queryInfo: { page: 1, size: state.queryInfo.size },
      };
    }

    default:
      return state;
  }
}

export default OrganizationReducer;
